
define('ldsh!modules/lp_info/templates/navigation', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="date-filter-trigger standalone-filter js-datepicker-button">\n  <div class="ed-btn ed-btn-secondary-action">\n    <span class="txt" data-i18n="landingPage.datepicker.button">Filtrar por fecha</span>\n  </div>\n</div>';

}
return __p
};});

